<template>
    <div class="similar-panel-wrapper">
        <Tabs :tabsConfig="curTabsConfig" @tabClick="tabClick" :currentIndex="currentIndex">
            <span slot="ExistingSimilars" class="total-similars">（{{ similarCount }}）</span>
            <component :is="currentComponentName" :questionId="questionId" :sceneId="sceneId" />
        </Tabs>
    </div>
</template>

<script>
import Tabs from "@/views/zhiji/bComponents/switchs/Tabs";
import ExistingSimilars from "./ExistingSimilars";
import RecommendSimilars from "./RecommendSimilars";

export default {
    name: "SimilarPanel",
    props: ["currentTab", "hasRecommendSimilar", "questionId", "sceneId"],
    components: {
        Tabs,
        ExistingSimilars,
        RecommendSimilars
    },
    data() {
        return {
            currentComponentName: this.currentTab
        };
    },
    computed: {
        tabsConfig() {
            return [
                {
                    tabName: this.$t("zhiji.knowlege.quesEditModal.simliarQues"),
                    contentName: "ExistingSimilars"
                },
                {
                    tabName: this.$t("zhiji.knowlege.quesEditModal.recommendSimilar"),
                    contentName: "RecommendSimilars"
                }
            ];
        },
        currentIndex() {
            return this.currentTab === "ExistingSimilars" ? 0 : 1;
        },
        curTabsConfig() {
            // TODO 一期不上推荐问法
            return [this.tabsConfig[0]];
        },
        similarCount() {
            return this.getStorePorp("totalSimilar");
        }
    },
    methods: {
        tabClick(data) {
            this.currentComponentName = data.componentName;
        },
        getStorePorp(propName) {
            return this.$store.state.zhiji.questionEdit[propName];
        }
    }
};
</script>

<style lang="less" scoped>
.similar-panel-wrapper {
    .total-similars {
        font-size: 14px;
        color: #9b9ba3;
        font-weight: normal;
    }
}
</style>
